import { canAcceptThisMessage } from "../../utils/message";
import constant from "src/constant";
import { Message } from "element-ui";
import main from "src/main";
import moment from "moment";
import service from "../../service";
import newCMD from "src/constant/newCMD.js";
import { scrollToBottom } from "src/app/customer/utils";

//客户端需要显示的指令信息数据
const ShowCustomerSysMessage = [
  constant.COMMAND_TYPE.CT_MATCH, //1
  constant.COMMAND_TYPE.CT_TRANSFER, //2
  constant.COMMAND_TYPE.CT_KICK, //7
  constant.COMMAND_TYPE.CT_INVITE_REVIEW, //6  邀请评价
  // constant.COMMAND_TYPE.CT_AFTER_EVALUTATION, //12  客户已评价
  constant.COMMAND_TYPE.CT_WELCOME_MSG, //8
  constant.COMMAND_TYPE.CT_DISCONNECT, //10
  constant.COMMAND_TYPE.CT_CLOSEMSG, //20
  constant.COMMAND_TYPE.MT_TEXT_BANK, //11
  constant.COMMAND_TYPE.MT_TEXT_PHOTO, //13
  constant.COMMAND_TYPE.CT_CLOSE, //14
  constant.COMMAND_TYPE.CT_SNATCH_CONVERSATION_IN, //25
  constant.COMMAND_TYPE.CT_ISCHECK_ORDER //28
  // constant.COMMAND_TYPE.CT_NOTICE_MESSAGE
];

export default {
  namespaced: true,
  state: () => ({
    messages: [],
    messageMap: {},
    messageImgs: [], //上传的图片对消息
    resendType: 0 //0：否，1：是
  }),
  getters: {},
  actions: {
    async initMessage({ commit }, { customer, messages = [] }) {
      messages = _.sortBy(messages, "chatTime");
      commit("setMessages", {
        customerId: customer.userId ? customer.userId : customer.customerId,
        messages
      });
    },
    acceptMessage({ dispatch, commit, rootState, rootGetters }, messagePack) {
      /** 如果打开了多个页面，先打开的页面应该关闭 **/
      if (!canAcceptThisMessage(rootState.userId)) {
        dispatch("closeChannel", null, { root: true });
        commit("modal/setIsShowWinTagClose", true, { root: true });
        return;
      }

      const messageTData = utils.parseScoketJSON(messagePack);

      if (messageTData.cmd === "P01") {
        console.log(
          "==================ws=================",
          messageTData.data,
          "==================ws================="
        );
      }

      const messageData = messageTData.data;

      // todo test
      // if(messageData.sort === 18){
      //   return;
      // }

      let channelId, msgId, createTime, messageType, commandType, userId;

      if (messageData.messageType != constant.MESSAGE_TYPE.MT_COMMAND) {
        /** 如果不是系统指令 **/
        channelId = messageData.channelId;
        msgId = messageData.msgId;
        createTime = messageData.createTime;
        messageType = messageData.messageType;
        commandType = messageData.commandType;
        userId = messageData.customerId;
      } else {
        /** 如果是系统指令 **/
        if (messageData.detail) {
          channelId = messageData.detail.channelId;
          msgId = messageData.detail.msgId;
          createTime = messageData.detail.createTime;
          messageType = messageData.detail.messageType;
          commandType = messageData.detail.commandType;
          userId = messageData.detail.userId;
        }
        commandType = commandType ? commandType : messageData.commandType;
        createTime = createTime ? createTime : messageData.createTime;
        messageType = messageType ? messageType : messageData.messageType;
        msgId = msgId ? msgId : messageData.msgId;
        channelId = channelId ? channelId : messageData.channelId;
        userId = userId ? userId : messageData.userId;
      }

      // 判断 customerId 发送方的
      let customerId = "";

      /** 会话接入 **/
      if (
        commandType === constant.COMMAND_TYPE.CT_TRANSFER ||
        commandType === constant.COMMAND_TYPE.CT_SNATCH_CONVERSATION_IN
      ) {
        customerId = userId;
      } else {
        //   if (utils.isCustomer()) {
        customerId = rootState.userId;
        //   } else {
        //     customerId = userId;
        //   }
      }

      let userName = _.get(messageData, "detail.userName", "");
      let serverName =
        _.get(messageData, "detail.serverName", "") ||
        messageData.serverName ||
        rootState.serverName;
      let transferServerName = _.get(
        messageData,
        "detail.transferServerName",
        ""
      );
      let transferServerAliasName = _.get(
        messageData,
        "detail.transferServerAliasName",
        ""
      );

      const sort = _.get(messageData, "sort", -1);
      // console.log(messageData.sort, 'sort')

      let serverAlias = _.get(messageData, "detail.serverAlias", "");
      let serverImage = _.get(messageData, "detail.serverImage", "");
      let customerImgUrl = _.get(messageData, "customerImgUrl", "");
      let customerName = _.get(messageData, "customerName", "");

      messageData.customerId = customerId;

      let sendFlag = false;

      // 客户端接收消息判断
      if (customerId === messageData.userId) {
        console.log("客户端接收消息", utils.isCustomer());
        let messageBox = document.querySelector("#messageBox");
        if (
          messageBox.scrollHeight -
            messageBox.scrollTop -
            messageBox.offsetHeight <
          250
        ) {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
        }
      }
      sendFlag = userId !== rootGetters["self"].userId;

      let content =
        messageData.content == "自动回复语"
          ? messageData.detail.content
          : messageData.content;
      let message = {
        channelId,
        msgId,
        sort,
        chatTime: createTime,
        content,
        userId,
        width: messageData.width,
        height: messageData.height,
        detail: messageData.detail,
        type: messageType,
        filePath: _.get(messageData, "filePath", ""),
        commandType,
        sendFlag,
        userName,
        serverName,
        transferServerName,
        noticeInfo: messageData.noticeInfo,
        serverAlias: serverAlias ? serverAlias : rootState.serverAlias,
        serverImage: serverImage ? serverImage : rootState.serverImage,
        transferServerAliasName,
        payDetail: messageData.payDetail,
        orderDetail: messageData.orderDetail,
        messageTemplate: messageData.messageTemplate,
        isSelect: messageData.isSelect,
        customerImgUrl: customerImgUrl,
        customerName: customerName
      };

      // 转接
      if (
        commandType === constant.COMMAND_TYPE.CT_TRANSFER ||
        commandType === constant.COMMAND_TYPE.CT_SNATCH_CONVERSATION_IN
      ) {
        message.serverId = _.get(messageData, "detail.serverId", "");
      }

      //  客户端匹配会话
      if (commandType === constant.COMMAND_TYPE.CT_MATCH) {
        message.serverId = _.get(messageData, "detail.serverId", "");
        message.conversationTip = constant.MESSAGE_TYPE.MT_CHANNEL_TIP;
      }
      const pushStore = rootGetters["target"].userId === customerId;

      if (messagePack.cmd === newCMD.CMD.C_ONCONNECT) {
        utils.setProp("serverTime", messagePack.data.createTime * 1000);
        const serverTime = moment(messagePack.data.createTime, "X");
        const localTime = moment();
        utils.log(
          `socket 服务器时间`,
          serverTime.format("YYYY-MM-DD HH:mm:ss")
        );
        utils.log(`本机时间`, localTime.format("YYYY-MM-DD HH:mm:ss"));
        const diff = localTime.diff(serverTime, "milliseconds");
        utils.setProp("diffTime", diff);
      }
      if (
        message.type == constant.MESSAGE_TYPE.MT_TEXT ||
        message.type == constant.MESSAGE_TYPE.MT_IMAGE ||
        message.type == constant.MESSAGE_TYPE.MT_ORDER_CHECKED
      ) {
        dispatch("saveMessage", { customerId, message, pushStore });
        // dispatch("acceptMessage", message, { root: true });
      }

      if (messageType == constant.MESSAGE_TYPE.MT_COMMAND) {
        message = utils.commandMessageFormat(message);
        dispatch("saveMessage", { customerId, message, pushStore });
        dispatch("acceptCommand", message, { root: true });
      }

      if (
        commandType === constant.COMMAND_TYPE.MT_TEXT_BANK ||
        commandType === constant.COMMAND_TYPE.MT_TEXT_PHOTO
      ) {
        dispatch("saveMessage", { customerId, message, pushStore });
      }
    },
    sendMessage(
      { dispatch, state, rootGetters },
      {
        orderList,
        customerId,
        channelId,
        content = "",
        pushStore = true,
        type = constant.MESSAGE_TYPE.MT_TEXT,
        filePath = "",
        localPath = "",
        width,
        height,
        socketStatus,
        payDetail = {},
        resendType = 0,
        orderDetail,
        msgId = "",
        createTime = 0,
        isOrder = false
      }
    ) {
      if (!channelId) {
        channelId = rootGetters["target"].channelId;
      }
      // 发送方
      const selfId = rootGetters["self"].userId;
      // 接收方
      const { userId } = rootGetters["target"];
      msgId = resendType ? msgId : utils.getUUID();
      // const createTime = utils.getTime();
      createTime = resendType ? createTime : utils.getTime();
      if (!customerId) customerId = rootGetters["currCustomerId"];

      const messageData = {
        userId,
        channelId,
        msgId,
        deviceType: utils.getDeviceType(),
        deviceId: utils.getDeviceID(),
        messageType: type,
        createTime,
        chatTime: createTime,
        customerId: selfId,
        content,
        filePath,
        payDetail,
        orderDetail,
        width,
        height,
        resendType
      };
      utils.log("发送消息 => ", messageData);

      const message = {
        channelId,
        msgId,
        userId,
        chatTime: createTime,
        content,
        type,
        sendFlag: utils.getSendFlag(),
        filePath,
        localPath,
        createTime,
        serverName: state.serverName,
        serverImage: state.serverImage,
        payDetail,
        orderDetail,
        socketStatus,
        width,
        height
      };
      message.SENDSTATUS = 1;
      // dispatch("saveMessage", { customerId, message, pushStore });
      // 保存消息到数据库
      // api消息体
      if (isOrder) {
        messageData.isSelect = 0;
        messageData.clientType = 2;
        // messageData.customerId = customerId;
        messageData.orderType = parseInt(messageData.orderDetail.platformOrder);
        messageData.sourceOrder = orderList;
        service
          .sendOrder(messageData)
          .then(res => {
            if (res && res.code == 200) {
              message.SENDSTATUS = 2;
              let serviceTime = res.data.serverDate;
              message.chatTime = serviceTime;
              message.createTime = serviceTime;
              // dispatch("saveMessage", { customerId, message, pushStore });
            } else if (res && res.code == "1021") {
              Message.closeAll();
              Message.error({
                message: res.msg,
                duration: 5000
              });
              message.SENDSTATUS = 3;
              // dispatch("saveMessage", { customerId, message, pushStore });
            } else {
              message.SENDSTATUS = 3;
              // dispatch("saveMessage", { customerId, message, pushStore });
            }
          })
          .catch(() => {
            message.SENDSTATUS = 3;
            // dispatch("saveMessage", { customerId, message, pushStore });
          });
      } else {
        service
          .sendMsg(messageData)
          .then(res => {
            if (res && res.code == 200) {
              message.SENDSTATUS = 2;
              let serviceTime = res.data.serverDate;
              message.chatTime = serviceTime;
              message.createTime = serviceTime;
              dispatch("saveMessage", { customerId, message, pushStore });
            } else if (res && res.code == "1021") {
              Message.closeAll();
              Message.error({
                message: res.msg,
                duration: 5000
              });
              message.SENDSTATUS = 3;
              dispatch("saveMessage", { customerId, message, pushStore });
            } else {
              message.SENDSTATUS = 3;
              dispatch("saveMessage", { customerId, message, pushStore });
            }
            // dispatch("saveMessage", { customerId, message, pushStore });
          })
          .catch(() => {
            message.SENDSTATUS = 3;
            dispatch("saveMessage", { customerId, message, pushStore });
            // dispatch("saveMessage", { customerId, message, pushStore });
          });
      }
    },
    async saveMessage({ commit }, { customerId, message }) {
      commit("addMessage", { customerId, message });
      if (message && message.type === constant.MESSAGE_TYPE.MT_IMAGE) {
        let img = new Image();
        img.onload = () => {
          const { vm } = main.getVueMachine();
          vm.eventBus.$emit("scrollMessageBox");
        };
        img.src = message.filePath;
      }
    },
    addSysMessage(
      { rootGetters, dispatch },
      { content, type = constant.MESSAGE_TYPE.MT_TEXT }
    ) {
      const customerId = rootGetters["self"].userId;
      const { channelId } = rootGetters["target"];

      const message = {
        channelId,
        msgId: utils.getUUID(),
        chatTime: utils.getTime(),
        content,
        type,
        sendFlag: true
      };
      dispatch("saveMessage", { customerId, message, pushStore: true });
    }
  },
  mutations: {
    //客服端用这个添加消息
    setMessages(state, { customerId, messages = [] }) {
      const map = _.cloneDeep(state.messageMap);
      const limit = ShowCustomerSysMessage;

      const filterMessagae = messages.filter(
        s =>
          s.type != constant.MESSAGE_TYPE.MT_COMMAND ||
          (s.type === constant.MESSAGE_TYPE.MT_COMMAND &&
            limit.includes(s.commandType))
      );
      map[customerId] = [...filterMessagae];
      state.messageMap = { ...map };
    },
    //客户端用这个添加信息
    addMessage(state, { customerId, message, addType = "push" }) {
      // debugger;
      const map = _.cloneDeep(state.messageMap);
      if (!map[customerId]) map[customerId] = [];

      const limit = ShowCustomerSysMessage;

      if (message && message.type === constant.MESSAGE_TYPE.MT_COMMAND) {
        //如果该消息为系统消息
        if (limit.includes(message.commandType)) {
          // map[customerId][addType](message);
          if (message && message.msgId) {
            const findResult = map[customerId].find(
              ele => ele.msgId == message.msgId
            );
            !findResult && map[customerId][addType](message);
          }
        } else {
          //不显示该条指令信息
        }
      } else {
        // 去重
        const findResult = map[customerId].findIndex(
          ele => ele.msgId == message.msgId
        );
        if (findResult == -1) {
          map[customerId][addType](message);
        } else {
          let obj = JSON.parse(JSON.stringify(map[customerId][findResult]));
          obj.SENDSTATUS = message.SENDSTATUS;
          map[customerId][findResult] = message;
        }
      }
      state.messageMap = { ...map };
    },
    setState(state, data = {}) {
      Object.keys(data).forEach(key => {
        state[key] = data[key];
      });
    }
  }
};
